/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import DeleteIcon from '@mui/icons-material/Delete'


export const doesFileSizeExceed = (fileSize, maxFileSize) => {
  if (fileSize > maxFileSize) {
    return true
  } else {
    return false
  }
}

export const ImageUploader = (props) => {
  const { t } = useTranslation()
  // eslint-disable-next-line
  const { allowedFormats, images, setImages, maxSize, maxImages } = props
  // const [images, setImages] = useState([])
  const [error, setError] = useState('')

  const handleFilesChange = (e) => {
    const files = Array.from(e.target.files)
    const totalImg = images.length + files.length
    if (totalImg < maxImages) {
      const validImages = []
      const maxSizeInBytes = maxSize * 1024 * 1024
      for (const file of files) {
        const isFileSizeExceeded = doesFileSizeExceed(file.size, maxSizeInBytes)
        const fileType = file.type.toLowerCase()
        const fileName = file.name.toLowerCase()
        if (allowedFormats.includes('JPG') && allowedFormats.includes('JPEG') && !fileName.endsWith('.jpg') && !fileName.endsWith('.jpeg') && fileType !== 'image/jpeg' && isFileSizeExceeded) {
          setError(t('demo.uploadJpgTypeandSizeErr', { noOfMb: maxSize }))
          return
        } else if (allowedFormats.includes('JPG') && allowedFormats.includes('JPEG') && !fileName.endsWith('.jpg') && !fileName.endsWith('.jpeg') && fileType !== 'image/jpeg') {
          setError(t('demo.uploadJpgType'))
          return
        } else if (isFileSizeExceeded) {
          setError(t('demo.fileSizeExceeded', { noOfMb: maxSize }))
          return
        }
        // if (allowedFormats.includes('JPG') && allowedFormats.includes('JPEG') && !fileName.endsWith('.jpg') && !fileName.endsWith('.jpeg') && fileType !== 'image/jpeg') {
        //   setError(t('demo.uploadJpgType'))
        //   return
        // }
        // if (file.size > maxSizeInBytes) {
        //   setError(t('demo.uploadJpgTypeandSizeErr', { noOfMb: maxSize }))
        //   return
        // }

        validImages.push({
          id: Math.random().toString(36).substr(2, 9),
          file,
          url: URL.createObjectURL(file),
        })
      }

      setImages(prev => [...prev, ...validImages])
      setError('')
      e.target.value = null
    } else {
      if (maxImages > 2) {
        setError(t('demo.maxSize'))
      } else {
        setError(t('demo.retakeMaxSize'))
      }
    }
  }

  const removeImage = (id) => {
    setImages(prev => prev.filter(img => img.id !== id))
  }

  return (
    <div style={{
      width: '500px',
      height: '450px',
      overflow: 'hidden'
    }}>
      <h2>{t('smartCatalog.uploadBt')}: </h2>
      <h3>{t('smartCatalog.selectImages')}: {images.length}</h3>
      <input
        type="file"
        accept="image/jpeg,image/jpg"
        multiple
        onChange={handleFilesChange}
        style={{ marginBottom: 10 }}
      />
      {error && <div style={{ color: 'red', marginBottom: 10 }}>{error}</div>}
      <div style={{
        width: '500px',
        height: '270px',
        border: '1px solid #ccc',
        padding: 10,
        borderRadius: 4,
        overflowY: 'scroll'
      }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          {images.map(img => (
            <div key={img.id} style={{ position: 'relative', width: 98, height: 98, border: '1px solid #ccc', borderRadius: 4, overflow: 'hidden' }}>
              <img src={img.url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              <DeleteIcon
                onClick={() => removeImage(img.id)}
                style={{
                  position: 'absolute', fontSize: 'small', top: 4, right: 4, background: 'rgba(0,0,0,0.6)', color: 'white', border: 'none', borderRadius: '50%', cursor: 'pointer'
                }}
              />
            </div>
          ))}
        </div>
      </div>

    </div>
  )
}

ImageUploader.propTypes = {
  images: PropTypes.array.isRequired,
  setImages: PropTypes.func.isRequired,
}

ImageUploader.defaultProps = {
  images: [],
  setImages: () => {},
}